import useRedirect from '../../hooks/useRedirect';

const NoMatchRouteComponent = (): null => {
  useRedirect(true, window.APP_CONFIG.apiHost);
  return null;
};

export default NoMatchRouteComponent;
